module.exports = __webpack_public_path__ + "media/images/flags/cg-440e321a39cf550b0bec17d9fd107038.svg";